export const DESIGN_SYSTEM_JS = window.REACT_APP_DESIGN_SYSTEM_JS;
export const DESIGN_SYSTEM_CSS = window.REACT_APP_DESIGN_SYSTEM_CSS;

export const LOCALE = window.REACT_APP_LOCALE || 'es-CL';
export const LOCALE_PATH =
  window.REACT_APP_LOCALE_PATH || `/locales/${LOCALE}/`;

// No sacar window.API_BASE_URL
export const API_URL = window.API_BASE_URL;

export const API_BASE_URL = API_URL + '/api';
export const TinyMCE_ApiKey =
  'no89skh86yibdbm71do29mqz4ldjyv6h6ix52vctyv798ztf';
